import { useLocation } from "react-router-dom";
import { PitStopButton } from "./PitStopButton";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function GlobalPitStop() {
  const { pathname } = useLocation();
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Hide on auth, onboarding, and chat (where assistant already lives or isn't needed), or if not logged in
  // Also hide on public pages like index, reset password, privacy, terms.
  if (
    !session ||
    pathname === "/" ||
    pathname === "/auth" || 
    pathname.startsWith("/onboarding") ||
    pathname === "/chat" ||
    ["/reset-password", "/privacy", "/terms"].includes(pathname)
  ) {
    return null;
  }

  return (
    <div className="fixed top-3 left-1/2 -translate-x-[50px] z-[55] animate-pulse-slow">
      <div className="relative">
        <div className="absolute inset-0 bg-primary/20 rounded-full blur-md animate-pulse"></div>
        <PitStopButton />
      </div>
    </div>
  );
}
